import { rem } from '../../../utils/rem';
import { tundora } from '../colors';
export var MuiDialog = {
    styleOverrides: {
        paper: {
            borderWidth: rem(1),
            borderColor: tundora,
            borderStyle: 'solid',
        },
    },
};
